define('all/paymentServices-toggles',['jquery', 'module'], function ($, module) {
    'use strict';

    var configuration = module.config();

    function isActive(feature) {
        return configuration[feature];
    }

    function useNewPaymentFormDataService() {
        return isActive('payment-form-data-service');
    }

    function useOldPaymentFormFlows() {
        return !isActive('payment-form-data-service');
    }

    return {
        isActive: isActive,
        useNewPaymentFormDataService: useNewPaymentFormDataService,
        useOldPaymentFormFlows: useOldPaymentFormFlows
    };
});

